import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmRefundVO {
  id?: number
  caseId: number
  receiptId?: number
  amount: number
  reason: string
  status?: string
  caseTitle?: string
  firmCaseNo?: string
  remark?: string
}

export interface FirmRefundPageReq extends PageParam {
  caseId?: number
  status?: string
}

export const FirmRefundApi = {
  create: (data: FirmRefundVO) => request.post({ url: '/lawyer/firm/refund/create', data }),
  update: (data: FirmRefundVO) => request.put({ url: '/lawyer/firm/refund/update', data }),
  delete: (id: number) => request.delete({ url: '/lawyer/firm/refund/delete?id=' + id }),
  page: (params: FirmRefundPageReq) =>
    request.get<PageResult<FirmRefundVO>>({ url: '/lawyer/firm/refund/page', params }),
  submit: (id: number) => request.put({ url: '/lawyer/firm/refund/submit?id=' + id }),
  approve: (data: { id: number; approved: boolean; comment?: string }) =>
    request.put({ url: '/lawyer/firm/refund/approve', data }),
  confirmRefund: (id: number) => request.put({ url: '/lawyer/firm/refund/confirm-refund?id=' + id }),
  void: (id: number) => request.put({ url: '/lawyer/firm/refund/void?id=' + id })
}
